import { motion } from "framer-motion";

// Line-by-line masked reveal used across the site.
export const RevealLines = ({ lines, className = "", delay = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="reveal-mask">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{
            duration: 0.9,
            delay: delay + i * 0.12,
            ease: [0.16, 1, 0.3, 1],
          }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] },
  }),
};

export const Overline = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-2 font-mono-tech text-[11px] uppercase tracking-[0.28em] text-cyber-cyan ${className}`}
  >
    <span className="h-px w-6 bg-cyber-cyan/60" />
    {children}
  </span>
);
